// function to fetch error message declared here
export const fetchErrorMessage = (error: any): string => {
  const res = error.response.data; // safer access

  let message = 'Something went wrong!';

  if (res) {
    if (typeof res.message === 'string') {
      // Case 1: plain string message
      message = res.message;
    } else if (Array.isArray(res.message)) {
      // Case 2: message is an array
      message = res.message.join(', ');
    } else if (typeof res === 'object' && !res.message) {
      // Case 3: field errors as object
      message = Object.values(res).flat().join(', ');
    }
  }

  return message;
};
